<div class="past-orders-page">
  <header class="page-header">
    <div>
      <h1>Past Orders</h1>
      <p>Terminal orders for this conversation.</p>
    </div>

    <a mat-stroked-button [routerLink]="backRoute()" class="back-btn">
      <mat-icon aria-hidden="true">arrow_back</mat-icon>
      Back to My Cases
    </a>
  </header>

  <div class="past-orders-body">
    @if (loading()) {
      <div class="loading-state">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else if (error()) {
      <div class="error-state">{{ error() }}</div>
    } @else if (!conversationId()) {
      <div class="empty-state">No conversation context. Navigate here from a case.</div>
    } @else {
      <section class="stats-grid">
        <article class="stat-card">
          <span class="stat-label">Completed orders</span>
          <strong>{{ completedCount() }}</strong>
        </article>
        <article class="stat-card">
          <span class="stat-label">Cancelled orders</span>
          <strong>{{ cancelledCount() }}</strong>
        </article>
        <article class="stat-card">
          <span class="stat-label">Preferred provider</span>
          <strong>{{ preferredProvider() }}</strong>
        </article>
      </section>

      @if (orders().length === 0) {
        <div class="empty-state">No past orders for this conversation.</div>
      } @else {
        <div class="filter-bar">
          <div class="filter-search">
            <mat-icon class="search-icon">search</mat-icon>
            <input
              class="search-input"
              type="search"
              placeholder="Search by order code, service, or provider…"
              autocomplete="off"
              [value]="searchQuery()"
              (input)="searchQuery.set($any($event.target).value)"
            />
          </div>

          <select
            class="filter-select"
            [ngModel]="statusFilter()"
            (ngModelChange)="statusFilter.set($event)"
          >
            @for (opt of statusFilterOptions; track opt.value) {
              <option [value]="opt.value">{{ opt.label }}</option>
            }
          </select>
        </div>

        @if (filteredOrders().length === 0) {
          <div class="empty-state">No past orders match the current filters.</div>
        } @else {
          <section class="table-card">
            <div class="table-head">
              <span>Order</span>
              <span>Service</span>
              <span>Provider</span>
              <span>Status</span>
              <span>Closed</span>
            </div>

            @for (order of filteredOrders(); track order.id) {
              <div class="table-row">
                <span class="order-code">{{ order.order_code }}</span>
                <span>{{ order.service_name || order.category || '—' }}</span>
                <span>{{ providerName(order) }}</span>
                <span
                  class="status-pill"
                  [class.tone-green]="statusTone(order.status) === 'green'"
                  [class.tone-orange]="statusTone(order.status) === 'orange'"
                  [class.tone-blue]="statusTone(order.status) === 'blue'"
                  [class.tone-red]="statusTone(order.status) === 'red'"
                >
                  {{ statusLabel(order.status) }}
                </span>
                <span>{{ order.updated_at | date: 'd MMM yyyy, h:mm a' }}</span>
              </div>
            }
          </section>
        }
      }
    }
  </div>
</div>